import { render, staticRenderFns } from "./pagePart3.vue?vue&type=template&id=d6d60afc&scoped=true"
import script from "./pagePart3.vue?vue&type=script&lang=js"
export * from "./pagePart3.vue?vue&type=script&lang=js"
import style0 from "./pagePart3.vue?vue&type=style&index=0&id=d6d60afc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6d60afc",
  null
  
)

export default component.exports